var options = {
    hooks: {},
    extensions: [],
    wrappers: [],
    navbar: {
        add: true,
        sticky: true,
        title: 'Menu',
        titleLink: 'parent'
    },
    onClick: {
        close: null,
        preventDefault: null,
        setSelected: true
    },
    slidingSubmenus: true
};
export default options;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/core/oncanvas/_options.js
// module id = 467
// module chunks = 0